module.exports = __webpack_public_path__ + "img/无忧售后.c09a7b64.jpg";